import moment from 'moment-timezone';

// TODO review timeZone as constant
const areTheSameDate = (a, b, timezone = moment.tz.guess()) => {
  const aMoment = moment(new Date(a)).tz(timezone).clone();
  const bMoment = moment(new Date(b)).tz(timezone).clone();

  return moment(aMoment).isSame(bMoment, 'day');
};

export default areTheSameDate;
